module.exports = __webpack_public_path__ + "media/valentines_tipping_tier_1-854271354985e84a48a28e18de5acb5a.mp3";